import styled from 'styled-components'

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-bottom: 1rem;

    .p-fileupload .p-fileupload-content {
        height: min-content;
        padding: 0rem 1rem;
    }

    .fileupload {
        margin-top: 0.25rem;
        width: 100%;
    }

    .p-fileupload .p-fileupload-buttonbar .p-button {
        background-color: #ba9d31;
        border: none;

        &:hover {
            background-color: #8b761b;
        }
    }
`
